import { render } from "./EllipsisIcon.vue?vue&type=template&id=77b25bf2"
import script from "./EllipsisIcon.vue?vue&type=script&lang=js"
export * from "./EllipsisIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__